export default function validateZipCode(country: string, zipCode: string) {

  switch (country) {

    case 'US':

      return /^\d{5}(-\d{4})?$/.test(zipCode); // US ZIP+4 format

    case 'CA':

      return /^[ABCEGHJ-NPRSTV-Z]\d[ABCEGHJ-NPRSTV-Z] ?\d[ABCEGHJ-NPRSTV-Z]\d$/i.test(zipCode); // Canadian postal code format

    case 'GB':

      return /^([A-Z]{1,2}\d[A-Z\d]? ?\d[A-Z]{2}|GIR ?0AA)$/i.test(zipCode); // UK postcode format

    default:

      return false; // Or handle other countries as needed

  }
  
}